import { Component, OnInit, ViewChild, AfterViewInit, ViewEncapsulation, Input, Renderer2, ChangeDetectorRef } from '@angular/core';
import { DispatchesService } from '../../shared/services/dispatches.service';
import { GlobalsService } from '../../shared/services/globals.service';
import { Subscription } from 'rxjs';
import { v_DispatchAssignmentBus } from '@app/cp/shared/models/v_DispatchAssignmentBus';
import { SelectionEvent, ColumnComponent } from '@progress/kendo-angular-grid';
import { BaseGridUIComponent } from '@app/cp/shared/base-components/base-grid-ui.component';
import { MessageType } from '@app/cp/shared/enums/MessageType';
import { MSFilterClass } from '@app/cp/shared/classes/filters/MSFilterClass';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { FormGroup, FormControl } from '@angular/forms';
import { CallbackPerson } from '@app/cp/shared/models/CallbackPerson';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'callback-person',
    templateUrl: './callback-person.component.html',
    styleUrls: ['./callback-person.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CallbackPersonComponent extends BaseGridEditLineComponent<v_DispatchAssignmentBus, null, DispatchesService>  {
    dispatchAssignmentStatusFC: MSFilterClass = new MSFilterClass('dispatchAssignmentStatusName');
    
    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: DispatchesService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;
        this.className = "v_DispatchAssignmentBus";
        this.appCode = "CallbackPerson";
        this.appName = "Callback Person";
    }
    @Input() active: boolean = false;
    //@Output() saved
    //createForm() {
    //    this.editForm = new FormGroup({
    //        'dispatchAssignmentId': new FormControl(),
    //        'wasCallback': new FormControl(),
    //        'fullName': new FormControl(),
    //        'assignedDate': new FormControl(),
    //        'dispatchAssignmentStatusName': new FormControl(),
    //        'assignedPersonId': new FormControl(),
    //        'assignedStatusId': new FormControl(), 
    //        'isPrimary': new FormControl(),
    //        'startDate': new FormControl(),
    //        'requireFieldValidation': new FormControl(),
    //        'assignedByPersonId': new FormControl(),
    //        'updateDt': new FormControl(),
    //        'updateUserId': new FormControl(),
    //        'insertDt': new FormControl(),
    //        'insertUserId': new FormControl()
    //    });

    //}
    //setForm() {
    //    this.editForm.patchValue({
    //        dispatchAssignmentId: this.selectedData.dispatchAssignmentId,
    //        dispatchId: this.selectedData.dispatchId,
    //        assignedPersonId: this.selectedData.assignedPersonId,
    //        assignedDate: this.selectedData.assignedDate,
    //        assignedStatusId: this.selectedData.assignedStatusId,
    //        isPrimary: this.selectedData.isPrimary,
    //        startDate: this.selectedData.startDate,
    //        requireFieldValidation: this.selectedData.requireFieldValidation,
    //        assignedByPersonId: this.selectedData.assignedByPersonId,
    //        updateDt: this.selectedData.updateDt,
    //        updateUserId: this.selectedData.updateUserId,
    //        insertDt: this.selectedData.insertDt,
    //        insertUserId: this.selectedData.insertUserId
    //    });
    //}
    protected save(data: v_DispatchAssignmentBus) {
        let changedRecs = this.gridData.filter(s => s.wasCallback !== s.originalWasCallback);
        let arrSave = [];
        for (let i = 0; i < changedRecs.length; i++) {
            let busObj: CallbackPerson = { dispatchAssignmentId: changedRecs[i].dispatchAssignmentId, wasCallback: changedRecs[i].wasCallback };
            arrSave.push(busObj);
        }
        this.svc_data.setCallbacks(arrSave).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {
                this.gridData.forEach(s => { s.originalWasCallback = s.wasCallback });
                this.clear();
            }
            this.closeWithInfo(info);
            //if (!info.saveError) {
            //    this.closeWithInfo(info);
            //}
            //else {
            //    this.closeWithInfo(info);
            //    //this.closed(false);
            //    //this.saveError(info.primaryReturn, info.message);
            //}
        });
    }
    clear() {
        super.clear();
        this.isChanged = false;
    }

    //id = dispatchAssignmentId
    //reAssign(id: any) {
    //    this.sendParentMessage(MessageType.reassignTech, null, null, id);
    //}
  //rowSelected(e: SelectionEvent) {
  //  this.selectedData = e.selectedRows[0].dataItem;
  //}
    //hide() {
    //    this.active = false;
    //}
    cancel() {
        this.closeWithInfo(null);
    }
    ok() {
        this.save(null);
//        this.closed.emit(true)
    }
    get canSave(): boolean {
        return this.isChanged;
    }
    isChanged: boolean = false;
    //get isDirty(): boolean {
    //    return (!this.readOnly && this.hasEditForm && this.editForm.dirty) || ;
    //}
    customCheckBoxChanged(e: any, dataItem: v_DispatchAssignmentBus, rowIndex: number, column: ColumnComponent, columnIndex: number, setEditMode: boolean = true) {
        let tmp = this.gridData.filter(s => s.originalWasCallback !== s.wasCallback);
        this.isChanged = CommonFunctions.hasArrayElementValue(tmp);
    }
}
//@Output() selected: EventEmitter < any > = new EventEmitter();
//@Output() closed: EventEmitter < any > = new EventEmitter<any>();
